import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { Box, Text, VStack } from '@chakra-ui/react';
import { PopoverBody, PopoverContent, PopoverRoot } from '@/components/ui/popover';
import FilterCheckboxOption from '@/components/util-component/FilterCheckboxOption';
import FilterPopoverTrigger from '@/components/util-component/FilterPopoverTrigger';
import { safeJsonParse } from '@/utils/storage';
export type NetworkPersonOption = {
  /** Stable identifier sent to the server (profile id for owners, email
   * for editors). */
  id: string;
  /** Human-readable label shown in the dropdown row. */
  label: string;
};
export type NetworkPersonFilter = {
  kind: 'all';
} | {
  kind: 'own';
} | {
  kind: 'users';
  ids: ReadonlyArray<string>;
};
type NetworkPersonFilterProps = {
  /**
   * Candidate people for the per-user checkbox rows. KBE has ~5–7
   * employees so the list is short.
   */
  options: ReadonlyArray<NetworkPersonOption>;
  value: NetworkPersonFilter;
  onChange: (next: NetworkPersonFilter) => void;
  /** Label for the "all" row, e.g. "All networks". */
  allLabel: string;
  /** Label for the "mine" row, e.g. "Created by me" / "Edited by me". */
  ownLabel: string;
  /** Header above the per-user rows, e.g. "Filter by owner". */
  sectionLabel: string;
  /** Accessible label for the trigger button. */
  ariaLabel: string;
  disabled?: boolean;
};
const NetworkPersonFilterDropdown = t0 => {
  const $ = _c(50);
  const {
    options,
    value,
    onChange,
    allLabel,
    ownLabel,
    sectionLabel,
    ariaLabel,
    disabled
  } = t0;
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] !== onChange) {
    t1 = () => onChange({
      kind: "own"
    });
    $[0] = onChange;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleSelectOwn = t1;
  let t2;
  if ($[2] !== onChange) {
    t2 = () => onChange({
      kind: "all"
    });
    $[2] = onChange;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleSelectAll = t2;
  let t3;
  if ($[4] !== onChange || $[5] !== value.ids || $[6] !== value.kind) {
    t3 = id => {
      const current = value.kind === "users" ? new Set(value.ids) : new Set();
      if (current.has(id)) {
        current.delete(id);
      } else {
        current.add(id);
      }
      if (current.size === 0) {
        onChange({
          kind: "own"
        });
        return;
      }
      onChange({
        kind: "users",
        ids: Array.from(current)
      });
    };
    $[4] = onChange;
    $[5] = value.ids;
    $[6] = value.kind;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleToggleUser = t3;
  let t4;
  if ($[8] !== allLabel || $[9] !== options || $[10] !== ownLabel || $[11] !== value) {
    t4 = describePersonFilter(value, options, allLabel, ownLabel);
    $[8] = allLabel;
    $[9] = options;
    $[10] = ownLabel;
    $[11] = value;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const triggerLabel = t4;
  const isOwnSelected = value.kind === "own";
  const isAllSelected = value.kind === "all";
  let t5;
  if ($[13] !== value.ids || $[14] !== value.kind) {
    t5 = value.kind === "users" ? new Set(value.ids) : new Set();
    $[13] = value.ids;
    $[14] = value.kind;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const selectedIds = t5;
  let t6;
  let t7;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      placement: "bottom-start"
    };
    t7 = d => setOpen(d.open);
    $[16] = t6;
    $[17] = t7;
  } else {
    t6 = $[16];
    t7 = $[17];
  }
  const t8 = value.kind !== "all";
  let t9;
  if ($[18] !== ariaLabel || $[19] !== disabled || $[20] !== t8 || $[21] !== triggerLabel) {
    t9 = <FilterPopoverTrigger active={t8} ariaLabel={ariaLabel} disabled={disabled} label={triggerLabel} />;
    $[18] = ariaLabel;
    $[19] = disabled;
    $[20] = t8;
    $[21] = triggerLabel;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== allLabel || $[24] !== handleSelectAll || $[25] !== isAllSelected) {
    t10 = <FilterCheckboxOption checked={isAllSelected} label={allLabel} onSelect={handleSelectAll} />;
    $[23] = allLabel;
    $[24] = handleSelectAll;
    $[25] = isAllSelected;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== handleSelectOwn || $[28] !== isOwnSelected || $[29] !== ownLabel) {
    t11 = <FilterCheckboxOption checked={isOwnSelected} label={ownLabel} onSelect={handleSelectOwn} />;
    $[27] = handleSelectOwn;
    $[28] = isOwnSelected;
    $[29] = ownLabel;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== options.length || $[32] !== sectionLabel) {
    t12 = options.length > 0 && <Box borderTopWidth="1px" mt={1} pt={1} px={2} py={1}><Text color="gray.500" fontSize="xs" fontWeight="medium">{sectionLabel}</Text></Box>;
    $[31] = options.length;
    $[32] = sectionLabel;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== handleToggleUser || $[35] !== options || $[36] !== selectedIds) {
    let t14;
    if ($[38] !== handleToggleUser || $[39] !== selectedIds) {
      t14 = option => <FilterCheckboxOption key={option.id} checked={selectedIds.has(option.id)} label={formatEditor(option.label)} onSelect={() => handleToggleUser(option.id)} />;
      $[38] = handleToggleUser;
      $[39] = selectedIds;
      $[40] = t14;
    } else {
      t14 = $[40];
    }
    t13 = options.map(t14);
    $[34] = handleToggleUser;
    $[35] = options;
    $[36] = selectedIds;
    $[37] = t13;
  } else {
    t13 = $[37];
  }
  let t14;
  if ($[41] !== t10 || $[42] !== t11 || $[43] !== t12 || $[44] !== t13) {
    t14 = <PopoverContent width="280px"><PopoverBody p={1}><VStack align="stretch" gap={0}>{t10}{t11}{t12}{t13}</VStack></PopoverBody></PopoverContent>;
    $[41] = t10;
    $[42] = t11;
    $[43] = t12;
    $[44] = t13;
    $[45] = t14;
  } else {
    t14 = $[45];
  }
  let t15;
  if ($[46] !== open || $[47] !== t14 || $[48] !== t9) {
    t15 = <PopoverRoot open={open} positioning={t6} onOpenChange={t7}>{t9}{t14}</PopoverRoot>;
    $[46] = open;
    $[47] = t14;
    $[48] = t9;
    $[49] = t15;
  } else {
    t15 = $[49];
  }
  return t15;
};
export default NetworkPersonFilterDropdown;

/**
 * Defensive parser for a stored person filter. Returns the parsed filter
 * only when the shape is valid; any corruption or partial data collapses
 * to undefined so the caller falls back to its default.
 */
export function parseStoredPersonFilter(raw: string | null | undefined): NetworkPersonFilter | undefined {
  const parsed = safeJsonParse(raw);
  if (!parsed || typeof parsed !== 'object') return undefined;
  const kind = (parsed as {
    kind?: unknown;
  }).kind;
  if (kind === 'all' || kind === 'own') return {
    kind
  };
  if (kind === 'users') {
    // `ids` is the current shape; `emails` is the legacy shape the old
    // editor filter persisted under `networkBrowserOwnerFilter`. Accept
    // both so saved editor selections survive the rename.
    const rawList = (parsed as {
      ids?: unknown;
    }).ids ?? (parsed as {
      emails?: unknown;
    }).emails;
    if (!Array.isArray(rawList)) return undefined;
    const validIds = rawList.filter((e): e is string => typeof e === 'string' && e.length > 0);
    if (validIds.length === 0) return undefined;
    return {
      kind: 'users',
      ids: validIds
    };
  }
  return undefined;
}
export function describePersonFilter(filter: NetworkPersonFilter, options: ReadonlyArray<NetworkPersonOption>, allLabel: string, ownLabel: string): string {
  if (filter.kind === 'all') return allLabel;
  if (filter.kind === 'own') return ownLabel;
  const ids = new Set(filter.ids);
  if (ids.size === 1) {
    const option = options.find(o => ids.has(o.id));
    return option ? formatEditor(option.label) : 'Unknown user';
  }
  return `${ids.size} people`;
}

/** Strip the @domain for compact display (Ancestralize is internal). */
export function formatEditor(value: string): string {
  const at = value.indexOf('@');
  return at > 0 ? value.slice(0, at) : value;
}